import image1 from './images/image1.png'
import image2 from './images/image2.png'
import image3 from './images/image3.png'
import image4 from './images/image.png'
import image5 from './images/image 8.png'
import image6 from './images/image 15.png'
import image7 from './images/image 2.png'
import image8 from './images/image 9.png'
import image9 from './images/image 12.png'
import image10 from './images/image 13.png'
import image11 from './images/image 14.png'
import image12 from './images/image 11.png'
import image13 from './images/image 16.png'
import image14 from './images/image 17.png'
import image15 from './images/image 18.png'
import image16 from './images/image 19.png'
import image17 from './images/someplant.png'
import data from './images/021-online payment.png'
import airtime from './images/Group.png'
const BestItems = [
    {id:1, image:image2, descr:"PS4 Wireless Controller", price:15000},
    {id:2, image:image3, descr:"Apple Air Pod", price:30000},
    {id:3, image:image17, descr:"Green Bowl Indoor Plant", price:12000}
]

export const recharge = [
    {id: 200, image:data, descr:"airtime"},
    {id: 201, image: airtime, descr:"data"}
]

export const categories = [
    {id:4, image:"https://images.unsplash.com/photo-1580327332925-a10e6cb11baa?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTN8fGdhbWluZ3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60", descr:"gaming"},
    {id:5, image:"https://images.unsplash.com/photo-1608538770329-65941f62f9f8?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8c3BlYWtlcnN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60", descr:"speakers"},
    {id:6, image:"https://media.istockphoto.com/photos/monstera-in-a-pot-isolated-on-white-background-close-up-of-tropical-picture-id1278906674?b=1&k=20&m=1278906674&s=170667a&w=0&h=PRsEw9KpsggCTUEqH_DqgtEKRt884wAGfQCQTeS8xBY=", descr:"plants"},
    {id:7, image:"https://images.unsplash.com/photo-1573920011462-eb3003086611?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fHBob25lc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60", descr:"phones"},
    {id:8, image:"https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8bGFwdG9wc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60", descr:"laptops"},
    {id:9, image:"https://media.istockphoto.com/photos/african-american-man-standing-at-night-with-vr-headset-on-virtual-picture-id1285766758?b=1&k=20&m=1285766758&s=170667a&w=0&h=IqnzSsS98MNfYiskevlksmz_eqhXtPlGq7PVcjWeP7Q=", descr:"VR"},
    
]

export const topdeals = [
    {id:9, image:image1, descr:"PS5 Dual Sense Wireless Controller", price:25000, deal:"15% OFF"},
    {id:10, image:image4, descr:"PS4 Wireless Controller", price:40000, deal:"50% OFF"},
    {id:11, image:image3, descr:"Apple Air Pod", price:25000, deal:"25% OFF"},
    {id:12, image:image2, descr:"PS4 Wireless Controller", price:47000, deal:"30% OFF"},
]

export const mygames = [
    {id:13, image:image6, descr:"Sony PlayStation 5 Consolewith Wireless Controller", price:250000},
    {id:14, image:image5, descr:"Wireless Mechanical Gaming Keyboard-Blue Switch", price:50000},
    {id:15, image:image7, descr:"Cool Red Xbox Series X|S Controller Skin", price:40000},
    {id:16, image:image8, descr:"Nintendo Switch Pro Controller", price:25000},
]
export const laptops = [
    {id: 120, image:image11, descr:"Apple Macbook Air Model A1465", price:"600,000"},
    {id: 121, image:image12, descr:"Gaming Laptops 15.6' 8G RAM SSD Laptop Intel Core I3", price:320000},
    {id: 122, image:image10, descr:"Microsoft Surface Laptop Go (12.40', Intel Core I5-10", price:250000},
    {id: 123, image:image9, descr:"Lenovo Flex 5 2-In-1 14 Touch 8core 8gb 512gb", price:130000},
]

export const phones = [
    {id: 124, image:image13, descr:"Tecno Camon Premier 15", price:15000, dec:"13% OFF"},
    {id: 125, image:image14, descr:"Apple Iphone 11 256GB", price:95000, dec:"13% OFF"},
    {id: 126, image:image15, descr:"Samsung Galaxy A11", price:72000, dec:"13% OFF"},
    {id: 127, image:image16, descr:"Apple Iphone 13 Pro Max", price:102000, dec:"40% OFF"}
]

export default BestItems